<!-- #HEADER -->
<div
  class="med_header-bar-wrapper w-100 d-flex justify-content-between align-items-center position-relative border-bottom"
>
  <div class="med_header-bar-start-col d-flex align-items-center gap-3 text-start" select="[header-left]">
    <ng-content select="[header-left]"></ng-content>
  </div>
  <div class="d-flex allign-items-center gap-3" select="[header-right]">
    <ng-content select="[header-right]"></ng-content>
  </div>
</div>
<!-- #HEADER -->
